import { Dropdown } from '@heroui/react'

import { MoreIcon } from './icons'

export interface RowAction {
  /** Returned to `onAction` when picked. */
  id: string
  label: string
}

interface RowActionsProps {
  /** Names the row in the trigger's accessible label — "Actions for Iced Latte". */
  label: string
  actions: RowAction[]
  onAction: (id: string) => void
  /** True while this row has a write in flight; the menu stays shut until it lands. */
  isBusy?: boolean
}

/**
 * The overflow menu at the end of a table row.
 *
 * `Dropdown.Trigger` is itself a button — wrapping one inside it nests two,
 * which React rejects outright, so the trigger is styled rather than wrapped.
 */
export function RowActions({ label, actions, onAction, isBusy }: RowActionsProps) {
  return (
    <Dropdown>
      <Dropdown.Trigger
        aria-label={`Actions for ${label}`}
        isDisabled={isBusy}
        className="text-muted hover:text-foreground hover:bg-surface inline-flex size-8 items-center justify-center rounded-full transition-colors disabled:opacity-50"
      >
        <MoreIcon width={16} height={16} />
      </Dropdown.Trigger>

      <Dropdown.Popover>
        <Dropdown.Menu onAction={(key) => onAction(String(key))} aria-label="Row actions">
          {actions.map((action) => (
            <Dropdown.Item key={action.id} id={action.id}>
              {action.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown>
  )
}
